export default {
  sm: `
  Today's records<br>
  become<br>
  tomorrow's<br>
  innovations  
  `,
  md: `
  Today's records<br>
  become tomorrow's<br>
  innovations  
  `,
  lg: `
  Today's records<br>
  become tomorrow's<br>
  innovations  
  `,
  xxl: `
  Today's records<br>
  become tomorrow's<br>
  innovations  
  `,
};
